import { Filter } from '@ais-ui/websockets';
import { useFilterContext } from '../Map/FilterContext';
import React, { useEffect, useState } from 'react';
import { isFilterApplied } from './utils';
import {
  Button,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@ais-ui/ui-core';
import { PiFunnel, PiFunnelFill } from 'react-icons/pi';

interface ApplyFilterButtonProps {
  filter: Filter;
}

export const ApplyFilterButton = ({ filter }: ApplyFilterButtonProps) => {
  const filterContext = useFilterContext();
  const [isApplied, setIsApplied] = useState<boolean>(
    isFilterApplied(filter, filterContext.customFilters)
  );

  useEffect(() => {
    setIsApplied(isFilterApplied(filter, filterContext.customFilters));
  }, [filter, filterContext.customFilters]);

  const onApply = () => {
    if (!isApplied) {
      filterContext.setCustomFilters([...filterContext.customFilters, filter]);
    } else {
      const newFilters = filterContext.customFilters.filter(
        (f) => f.uuid !== filter.uuid
      );
      filterContext.setCustomFilters(newFilters);
    }
  };

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button size="smIcon" variant="ghost" onClick={onApply}>
          {isApplied ? (
            <PiFunnelFill className="h-4 w-4" />
          ) : (
            <PiFunnel className="h-4 w-4"></PiFunnel>
          )}
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        {isApplied ? 'Remove filter' : 'Apply filter'}
      </TooltipContent>
    </Tooltip>
  );
};
